<template>
  <!-- Same dots loader the pages use while their data loads, so a route
       whose chunk is still downloading looks like a page that is loading. -->
  <div class="py-16">
    <BaseLoader />
  </div>
</template>

<script>
export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }]
  }
}
</script>
